import { matchSorter } from 'match-sorter';
import { Autocomplete, Typography } from 'seagull';
import { Accounting } from "../../types/api.model";
import { getAccountingDetails } from "./accounting.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export function QBOAccountField(_ref) {
  let {
    options,
    onChange: _onChange,
    textFieldProps,
    selectedOption,
    'data-testid': testid,
    noOptionsText = "No ".concat(getAccountingDetails(Accounting.QBO).name, " accounts")
  } = _ref;
  return /*#__PURE__*/_jsx(Autocomplete, {
    "data-testid": testid,
    value: selectedOption,
    options: options,
    onChange: (_, newOption) => _onChange(newOption),
    renderOption: _ref2 => {
      let {
        name
      } = _ref2;
      return /*#__PURE__*/_jsx(Typography, {
        ellipsis: true,
        children: name
      });
    },
    getOptionSelected: (option, value) => option.id === value.id,
    getOptionLabel: option => option.name,
    filterOptions: (options, _ref3) => {
      let {
        inputValue
      } = _ref3;
      return matchSorter(options, inputValue, {
        keys: ['name']
      });
    },
    noOptionsText: noOptionsText,
    textFieldProps: textFieldProps,
    selectOnFocus: true,
    disableClearable: true,
    multiple: false,
    freeSolo: false
  });
}